import { Nullable } from "common/records";
import { PaymentTermRecord } from "common/records/PaymentTerm";
import { RootState } from "common/reducers";
import { ids } from "common/selectors/idsManagement.selectors";
import { List } from "immutable";
import { createSelector } from "reselect";

const rootKey = "paymentTerms";

/**
 * Returns the byId from state
 * @param state The RootState
 * @returns the byId Map
 */
export const byId = (state: RootState) => state.getIn([rootKey, "byId"]);

/**
 * Returns the paymentTerm record for the given id
 * @param {RootState} state The RootState
 * @param {{paymentTermId: Nullable<number>}} props The paymentTermId
 * @returns {Nullable<PaymentTermRecord>} the paymentTerm record
 */
export const paymentTerm = (
  state: RootState,
  props: { paymentTermId: Nullable<number> },
): Nullable<PaymentTermRecord> =>
  typeof props.paymentTermId === "number" ? byId(state).get(props.paymentTermId) : undefined;

/**
 * Returns the ids from ids management
 * @param state The RootState
 * @returns the ids List
 */
export const paymentTermsIds = (state: RootState) => ids(state, { modelName: rootKey });

/**
 * Returns the list paymentTerm records for the ids in ids management
 * @param state The RootState
 * @returns {List<PaymentTermRecord>} The paymentTerms List
 */
export const paymentTerms = createSelector(
  [byId, paymentTermsIds],
  (byId, paymentTermsIds): List<PaymentTermRecord> =>
    paymentTermsIds.map((id) => byId.get(id as number)).filter((d) => !!d),
);
